var ExamAttemptAnswer = /** @class */ (function () {
    function ExamAttemptAnswer(obj) {
        this.id = obj.id;
        this.examAttemptId = obj.examAttemptId;
        this.examAnswerId = obj.examAnswerId;
    }
    return ExamAttemptAnswer;
}());
export default ExamAttemptAnswer;
